import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { doSignup } from '../actions'
import { GoogleSignupButton as Component } from '../../../Components/GoogleSignupButton';

const mapStateToProps = (state, params) => {
  return {
    ...state.googleAuth.signup,
    clientId:     state.googleAuth.clientId,
    userDefaults: state.login.userDefaults,
    text:         state.localization.dictionary.login.contGoogle
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    doSignup: data => dispatch(doSignup(data))
  }
}

class AuthGoogleSignupButton extends React.Component {
  static propTypes = {
    doSignup:     PropTypes.func,
    onSuccess:    PropTypes.func,
    onError:      PropTypes.func,
    clientId:     PropTypes.string,
    userDefaults: PropTypes.object,

    // Server responses saved into state
    response:     PropTypes.object,
    error:        PropTypes.object,
  }

  doSignup = (response) => {
    const profile = response.profileObj

    // TODO: Consider putting this mapping in the action
    this.props.doSignup({
      ...this.props.userDefaults,
      id_token:        response.tokenId,
      sso_accesstoken: response.accessToken,
      email:           profile.email,
      sso_firstname:   profile.givenName,
      sso_lastname:    profile.familyName,
      sso_avatar:      profile.imageUrl,

      // Google doesnt provide but PHP expects the key
      sso_gender: null,
    })
  }

  /**
   * Trigger the apporpriate events based on the current state.
   */
  UNSAFE_componentWillReceiveProps(props) {
    const { onSuccess, onError, response, error } = props

    onSuccess && response && onSuccess(response)
    onError && error && onError(error)
  }

  render() {
    const { onError, text, clientId } = this.props

    return (
      <Component
        onSuccess={ this.doSignup }
        onFailure={ onError }
        children={ text }
        clientId={ clientId } />
    )
  }
}

const AuthGoogleSignupButtonConnected = connect(
  mapStateToProps,
  mapDispatchToProps
)(AuthGoogleSignupButton)


export {
  AuthGoogleSignupButtonConnected as SignupButton
}
